import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, ArrowRight } from 'lucide-react';
import CosmicBackground from '../components/CosmicBackground';
import Watermark from '../components/Watermark';

const NameEntry = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');

  const handleContinue = () => {
    if (name.trim()) {
      localStorage.setItem('userName', name.trim());
      navigate('/place-of-birth');
    }
  };

  return (
    <CosmicBackground showAstroChart={true}>
      <Watermark position="bottom-right" opacity={0.3} />
      
      <div className="min-h-screen relative" data-testid="name-entry-screen">
        {/* Progress bar */}
        <div className="absolute top-14 left-0 right-0 flex gap-1 px-4">
          <div className="flex-1 h-1 bg-[#D4AF37] rounded-full" />
          <div className="flex-1 h-1 bg-gray-600 rounded-full" />
          <div className="flex-1 h-1 bg-gray-600 rounded-full" />
          <div className="flex-1 h-1 bg-gray-600 rounded-full" />
          <div className="flex-1 h-1 bg-gray-600 rounded-full" />
        </div>

        {/* Back button */}
        <button 
          onClick={() => navigate(-1)} 
          className="absolute top-14 left-4 text-white z-20"
        >
          <ChevronLeft className="w-6 h-6" />
        </button>

        {/* Content */}
        <div className="flex flex-col h-screen pt-24 px-6">
          {/* Title */}
          <h1 
            className="text-white text-3xl font-serif text-center mb-3"
            style={{letterSpacing: '0.1em'}}
          >
            ENTER YOUR NAME
          </h1>

          {/* Subtitle */}
          <p className="text-gray-400 text-center text-sm mb-12 px-4 md:px-8">
            It will help to generate a personalize horoscope, numerology and compatibility report.
          </p>

          {/* Input Field */}
          <div className="mb-8">
            <label className="text-gray-300 text-sm mb-2 block">Enter your Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter"
              className="w-full px-4 py-4 bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl text-white placeholder-gray-500 focus:outline-none focus:border-[#D4AF37] transition-colors"
              autoFocus
            />
          </div>

          {/* Spacer */}
          <div className="flex-1" />

          {/* Continue button */}
          <button
            onClick={handleContinue}
            disabled={!name.trim()}
            className="w-full py-4 bg-gradient-to-r from-[#D4AF37] to-[#F4D03F] text-[#0a1628] rounded-full font-semibold text-lg flex items-center justify-center gap-2 mb-8 disabled:opacity-50 hover:scale-105 transition-transform shadow-lg"
          >
            Continue
            <ArrowRight className="w-5 h-5" />
          </button>
        </div>
      </div>
    </CosmicBackground>
  );
};

export default NameEntry;